/*eslint-disable*/
import React from "react";
import Index from "./views/Index";
import Surveys from "./views/Surveys/Surveys";
import Funds from "./views/Funds/Funds";
import Documents from "./views/Documents/Documents";
import SurveyDetails from "./views/Surveys/SurveyDetails";
import { User, Users, UsersList } from "./views/Users/";
import UsersRules from "./views/Roles/Roles.tsx";
import Teams from "./views/Teams/TeamsList";
import Team from "./views/Teams/Team";
import Role from "./views/Roles/Role";
import Fund from "./views/Funds/Fund";
import Part from "./views/Funds/Part";
import Risk from "./views/Risk/Risk";
import ClientConfiguration from "./views/Configurations/ClientConfiguration";

const routes: any = [
  {
    path: "/index",
    name: "Dashboard",
    icon: "ni ni-tv-2 text-primary",
    component: () => <Index />,
    layout: "/admin",
  },

  {
    path: "/users",
    name: "Users",
    icon: "fa fa-users text-blue",
    component: () => <Users />,
    layout: "/admin",
    subMenu: [
      {
        path: "/users/user-list",
        name: "Users list",
        icon: "fa fa-list-ul text-blue",
        component: () => <UsersList />,
        layout: "/admin",
      },
      {
        path: "/users/teams",
        name: "Teams",
        icon: "fa fa-users text-blue",
        component: () => <Teams />,
        layout: "/admin",
      },
      {
        path: "/users/users-roles",
        name: "Users Roles",
        icon: "fa fa-lock text-blue",
        component: () => <UsersRules />,
        layout: "/admin",
      },
      {
        path: "/user/",
        name: "User edit",
        icon: "fa fa-user text-blue",
        component: () => <User />,
        layout: "/admin",
      },
      {
        path: "/role/",
        name: "Role edit",
        icon: "fa fa-user text-blue",
        component: () => <Role />,
        layout: "/admin",
      },
      {
        path: "/team/",
        name: "Team",
        icon: "fa fa-users text-blue",
        component: () => <Team />,
        layout: "/admin",
      },
    ],
  },
  {
    path: "/questionnaires",
    name: "Questionnaires",
    icon: "ni ni-bullet-list-67 text-red",
    component: () => <Surveys />,
    layout: "/admin",
  },
  {
    path: "/questionnaires/details/",
    name: "Questionnaire details",
    icon: "fa fa-cogs text-blue",
    component: () => <SurveyDetails />,
    layout: "/admin",
  },
  {
    path: "/funds",
    name: "Products",
    icon: "fas fa-th-large text-blue",
    component: () => <Funds />,
    layout: "/admin",
  },
  {
    path: "/funds/details",
    name: "Fund details",
    icon: "fas fa-th-large text-blue",
    component: () => <Fund />,
    layout: "/admin",
  },
  {
    path: "/parts/details/part",
    name: "Part details",
    icon: "fa fa-cogs text-blue",
    component: () => <Part />,
    layout: "/admin",
  },
  {
    path: "/risk-profile",
    name: "Risk Profile",
    icon: "fa fa-cogs text-red",
    component: () => <Risk />,
    layout: "/admin",
  },
  {
    path: "/configurations",
    name: "Configurations",
    icon: "ni ni-single-02 text-red",
    component: () => <ClientConfiguration />,
    layout: "/admin",
  },
];
export default routes;
